import React, { FC } from 'react'
import { TCurrencyPieChartDatum, ITooltipDatum } from '../../types'
import { LegendRowItem } from './LegendRowItem'

interface ICurrencyPieChartArcProps {
  arcFill: string
  arcPath: string
  datum: TCurrencyPieChartDatum
  onMouseLeave: () => void
  onMouseOver: (dataTooltip: ITooltipDatum) => (e: React.MouseEvent) => void
  totalValues: number
}

export const CurrencyPieChartArc: FC<ICurrencyPieChartArcProps> = ({
  arcFill,
  arcPath,
  datum,
  onMouseLeave,
  onMouseOver,
  totalValues,
}) => {
  const { label, value } = datum

  return (
    <g
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseOver({
        datum,
        color: arcFill,
        totalValues,
        renderedLabel: (
          <LegendRowItem datum={{ label, value }} totalValues={totalValues} color={arcFill} />
        ),
      })}
      key={`arc-${label}`}>
      <path d={arcPath} fill={arcFill} />
    </g>
  )
}
